import patternize from '@sdk/helpers/formatters/patternize';

import {
  NUMBER_FORMAT,
  NUMBER_REGEX,
} from './phone';

export default function phoneNumber(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  const formatted = patternize(value, {
    format: NUMBER_FORMAT,
  });

  if (NUMBER_REGEX.test(formatted)) {
    return false;
  }

  return true;
}

phoneNumber.message = function message(value, options = {}) {
  return options.message || 'não é um número válido';
};
